import { endpoints } from '../Constants';
import { authHeader } from '../Helpers';
import handleResponse from './helpers';

const kitIssuanceServices = {
	list,
};

// req.data: { storeId } plus { dateFrom: 'YYYY-MM-DD', dateTo } and/or { productionPlanIds: [] },
// optional includeHidden
function list(req = {}) {
	return fetch(endpoints.KIT_ISSUANCE_LIST, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify(req?.data || {}),
	}).then(handleResponse);
}

export default kitIssuanceServices;
